import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { object, array } from 'prop-types';
import { compose, graphql } from 'react-apollo';
import { default as getObjectProperty } from 'lodash.get';
import { withAnalytics } from '../../analytics';
import { Wrappers } from '../../components';
import { Queries } from '../../api';
import RecentAnnouncements from './RecentAnnouncements';
import AnnouncementDetail from './AnnouncementDetail';

const Announcement = ({ match, announcements, analytics }) => {
  const announcementDetail =
    announcements &&
    announcements.find(
      announcement =>
        announcement.id.toLowerCase() === match.params.id.toLowerCase()
    );

  const recentAnnouncements =
    announcements &&
    announcements.filter(
      announcement =>
        announcement.id.toLowerCase() !== match.params.id.toLowerCase()
    );

  const trackAnalytics = () => {
    if (announcementDetail) {
      analytics.trackEvent('Announcement Page Visited', {
        url: window.location.href,
        title: announcementDetail.title,
        id: announcementDetail.id
      });
    }
  };

  useEffect(() => {
    trackAnalytics();
  }, [match.params.id, announcements]);

  return (
    <Wrappers.Layout menu>
      <Container as="main">
        {announcementDetail && <AnnouncementDetail data={announcementDetail} />}
        {recentAnnouncements && (
          <RecentAnnouncements announcements={recentAnnouncements} />
        )}
      </Container>
    </Wrappers.Layout>
  );
};

Announcement.propTypes = {
  match: object,
  announcements: array
};

export default compose(
  graphql(Queries.getAnnouncements, {
    props: props => ({
      ...props,
      announcements: getObjectProperty(
        props,
        'data.getAnnouncements',
        undefined
      )
    })
  }),
  withRouter,
  withAnalytics
)(Announcement);



// WEBPACK FOOTER //
// ./src/pages/Announcement/index.js